// ثابت‌ها و برچسب‌های فارسیِ ماژول زنجیره تأمین
import { categoryLabelOfEventType, OBSOLETE_EVENT_TYPES } from "./supplyCategories";
import { faNum } from "../../utils/faNumberFormat";

export const EVENT_TYPES = [
  { v: "yarn_purchased", l: "خرید نخ", color: "blue", category: "yarn_purchase" },
  { v: "yarn_sent_to_knitter", l: "ارسال نخ به بافنده (قدیمی)", color: "geekblue", category: "knitting", obsolete: true },
  { v: "raw_fabric_produced", l: "خروج پارچهٔ خام (بافت) (قدیمی)", color: "cyan", category: "knitting", obsolete: true },
  { v: "raw_fabric_sent_to_dyeing", l: "خروجی بافندگی", color: "purple", category: "knitting" },
  { v: "dyed_fabric_received_from_dyeing", l: "خروج پارچهٔ رنگ‌شده از پوشان (قدیمی)", color: "magenta", category: "dyeing", obsolete: true },
  { v: "dyed_fabric_received_in_gharchak_warehouse", l: "خروجی رنگرزی", color: "green", category: "dyeing" },
  { v: "waste_registered", l: "ثبت ضایعات", color: "volcano", category: null },
  { v: "adjustment", l: "اصلاحیه", color: "orange", category: null },
  { v: "opening_balance", l: "مانده اول دوره", color: "default", category: null },
];

/** انواع قابل‌انتخاب در فیلتر/منو (بدون منسوخ‌ها؛ ضایعات و اصلاحیه حفظ می‌شوند) */
export const FILTERABLE_EVENT_TYPES = EVENT_TYPES.filter((e) => !e.obsolete && !OBSOLETE_EVENT_TYPES.has(e.v));

export const eventLabel = (v) => (EVENT_TYPES.find((e) => e.v === v) || {}).l || v;
export const eventColor = (v) => (EVENT_TYPES.find((e) => e.v === v) || {}).color || "default";
export const eventCategoryLabel = (v) => categoryLabelOfEventType(v);

export const STATUS_META = {
  draft: { l: "پیش‌نویس", c: "default" },
  confirmed: { l: "تأییدشده", c: "green" },
  needs_review: { l: "نیازمند بررسی", c: "orange" },
  disputed: { l: "مغایر", c: "red" },
  cancelled: { l: "لغوشده", c: "default" },
};
export const statusMeta = (s) => STATUS_META[s] || { l: s, c: "default" };

export const PARTY_TYPE_LABEL = {
  supplier: "تأمین‌کننده",
  knitting_workshop: "بافندگی",
  dyeing_provider: "رنگرزی",
  internal_warehouse: "انبار داخلی",
  other: "سایر (کارتن، چاپ، لیبل، …)",
};

export const CATEGORY_LABEL = {
  yarn: "نخ", raw_fabric: "پارچهٔ خام", dyed_fabric: "پارچهٔ رنگ‌شده",
  waste: "ضایعات", adjustment: "اصلاحیه",
};

export const fmtKg = (v) =>
  v == null ? "—" : `${faNum(Number(v), { maximumFractionDigits: 3 })} کیلو`;

/** قیمت ریالی — همیشه بدون اعشار (رند به نزدیک‌ترین عدد صحیح) */
export const fmtRial = (v) =>
  v == null || v === "" ? "—" : `${faNum(Math.round(Number(v)))} ریال`;

/** برای Ant Design Statistic — value باید عدد باشد؛ رشتهٔ fmtKg/fmtRial با Number → NaN و سلول خالی می‌شود. */
export const statFmtKg = (v) => fmtKg(v == null || v === "" ? null : Number(v));
export const statFmtRial = (v) => fmtRial(v == null || v === "" ? null : Number(v));
